import React, { forwardRef } from 'react';
import cx from 'classnames';

import useStyles from './styles';

interface CardWrapperProps {
  wrapperClass?: string;
  children: React.ReactNode;
}

const CardWrapper = forwardRef<HTMLDivElement, CardWrapperProps & React.HTMLProps<HTMLDivElement>>(
  ({ children, wrapperClass = '', ...props }, ref) => {
    const classes = useStyles();

    return (
      <div ref={ref} className={cx(classes.wrapper, wrapperClass)} {...props}>
        {children}
      </div>
    );
  },
);

export default CardWrapper;
